import styles from './NotFound.module.scss';

const NotFound = () => {
  return <div className={styles.notFound}>Page Not Found</div>;
};

export { NotFound };
